import React from 'react';

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

// UPVC/Flush Casement window colours with images
const upvcColours = [
  { id: 'white-grain', name: 'White Grain', image: `${BASE_URL}/upvc-windows-colours/white-grain.webp` },
  { id: 'heritage-white', name: 'Heritage White', image: `${BASE_URL}/upvc-windows-colours/heritage-white.webp` },
  { id: 'classic-cream', name: 'Classic Cream', image: `${BASE_URL}/upvc-windows-colours/classic-cream.webp` },
  { id: 'ice-cream', name: 'Ice Cream', image: `${BASE_URL}/upvc-windows-colours/ice-cream.webp` },
  { id: 'chartwell-green', name: 'Chartwell Green', image: `${BASE_URL}/upvc-windows-colours/chartwell-green.webp` },
  { id: 'agate-grey', name: 'Agate Grey', image: `${BASE_URL}/upvc-windows-colours/agate-grey.webp` },
  { id: 'aluminium-grey', name: 'Aluminium Grey', image: `${BASE_URL}/upvc-windows-colours/aluminium-grey.jpg` },
  { id: 'anthracite-grey', name: 'Anthracite Grey', image: `${BASE_URL}/upvc-windows-colours/anthracite-grey.jpg` },
  { id: 'smooth-anthracite-grey', name: 'Smooth Anthracite Grey', image: `${BASE_URL}/upvc-windows-colours/smooth-anthracite-grey.jpg` },
  { id: 'smooth-matt-anthracite', name: 'Smooth Matt Anthracite', image: `${BASE_URL}/upvc-windows-colours/smooth-matt-anthracite.jpg` },
  { id: 'smooth-matt-black', name: 'Smooth Matt Black', image: `${BASE_URL}/upvc-windows-colours/smooth-matt-black.webp` },
  { id: 'black-ash', name: 'Black Ash', image: `${BASE_URL}/upvc-windows-colours/black-ash.jpg` },
  { id: 'golden-oak', name: 'Golden Oak', image: `${BASE_URL}/upvc-windows-colours/golden-oak.jpg` },
  { id: 'english-oak', name: 'English Oak', image: `${BASE_URL}/upvc-windows-colours/english-oak.jpg` },
  { id: 'irish-oak', name: 'Irish Oak', image: `${BASE_URL}/upvc-windows-colours/irish-oak.jpg` },
  { id: 'rosewood', name: 'Rosewood', image: `${BASE_URL}/upvc-windows-colours/rosewood.jpg` },
  { id: 'ral-custom', name: 'RAL Custom Colour', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
  { id: 'not-sure', name: 'Not Sure', hex: '#D3D3D3' },
];

const ColourStep = ({ onSelect, selectedColour, product, style }) => {
  // Check if this should use UPVC colours (flush-casement or upvc styles)
  const shouldUseUpvcColours = () => {
    // Windows with flush-casement or upvc style
    if (product === 'windows' && (style === 'flush-casement' || style === 'upvc')) {
      return true;
    }
    return false;
  };

  // Define color options based on product and style
  const getColours = () => {
    // Use UPVC colours for flush-casement and UPVC windows
    if (shouldUseUpvcColours()) {
      return upvcColours;
    }

    // Aluminium Pivot and Residential doors colors (check style first before product)
    if (style === 'aluminium-pivot-doors' || style === 'aluminium-residential-doors') {
      return [
        { id: 'grey', name: 'Grey', hex: '#808080' },
        { id: 'black', name: 'Black', hex: '#000000' },
        { id: 'black-matt', name: 'Black Matt', hex: '#28282B' },
        { id: 'white', name: 'White', hex: '#FFFFFF' },
        { id: 'special-colours', name: 'Special Colours', image: `${BASE_URL}/aluminium-doors/colours/special-colours.jpg` },
        { id: 'special-textured', name: 'Special Textured Finishes', image: `${BASE_URL}/aluminium-doors/colours/special-textured-finishes.jpg` },
        { id: 'ral-custom', name: 'RAL Custom Colour', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
        { id: 'not-sure', name: 'Not Sure', hex: '#D3D3D3' },
      ];
    }

    // Composite door colors (Solidor range)
    if (product === 'front-back-doors') {
      return [
        { id: 'black', name: 'Black', hex: '#000000' },
        { id: 'schwarz-braun', name: 'Schwarz Braun', hex: '#2F2925' },
        { id: 'rosewood', name: 'Rosewood', hex: '#381611' },
        { id: 'deep-merlot', name: 'Deep Merlot', hex: '#5E2028' },
        { id: 'ruby-red', name: 'Ruby Red', hex: '#901320' },
        { id: 'tangerine', name: 'Tangerine', hex: '#E4541E' },
        { id: 'copper-flame', name: 'Copper Flame', hex: '#C35236' },
        { id: 'antique-rose', name: 'Antique Rose', hex: '#C26F73' },
        { id: 'champagne-blush', name: 'Champagne Blush', hex: '#C8969E' },
        { id: 'amber-gold', name: 'Amber Gold', hex: '#DB951D' },
        { id: 'buttercup-yellow', name: 'Buttercup Yellow', hex: '#C7B14C' },
        { id: 'green', name: 'Green', hex: '#26483A' },
        { id: 'forest-green', name: 'Forest Green', hex: '#677544' },
        { id: 'pistachio', name: 'Pistachio', hex: '#59A63E' },
        { id: 'chartwell-green', name: 'Chartwell Green', hex: '#8DA599' },
        { id: 'blue', name: 'Blue', hex: '#232B59' },
        { id: 'peacock-blue', name: 'Peacock Blue', hex: '#135C6B' },
        { id: 'pottery-blue', name: 'Pottery Blue', hex: '#4185A8' },
        { id: 'duck-egg-blue', name: 'Duck Egg Blue', hex: '#B1BFCC' },
        { id: 'midnight-grey', name: 'Midnight Grey', hex: '#36515D' },
        { id: 'anthracite-grey', name: 'Anthracite Grey', hex: '#54626C' },
        { id: 'granite-grey', name: 'Granite Grey', hex: '#636B6E' },
        { id: 'twilight-grey', name: 'Twilight Grey', hex: '#778796' },
        { id: 'french-grey', name: 'French Grey', hex: '#8A949D' },
        { id: 'painswick', name: 'Painswick', hex: '#CCCCCC' },
        { id: 'golden-oak', name: 'Golden Oak', hex: '#805F2C' },
        { id: 'irish-oak', name: 'Irish Oak', hex: '#A5884E' },
        { id: 'truffle-brown', name: 'Truffle Brown', hex: '#887D69' },
        { id: 'pebble-grey', name: 'Pebble Grey', hex: '#B8AFA0' },
        { id: 'cream', name: 'Cream', hex: '#F7EEDA' },
        { id: 'foiled-white', name: 'Foiled White', hex: '#F2EADD' },
        { id: 'white', name: 'White', hex: '#F8F0E3' },
        { id: 'ral-custom', name: 'RAL Custom Colour', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
        { id: 'not-sure', name: 'Not Sure', hex: '#D3D3D3' },
      ];
    }

    // Secondary glazing colors
    if (product === 'windows' && style === 'secondary-glazing') {
      return [
        { id: 'white', name: 'White', hex: '#FFFFFF' },
        { id: 'grey', name: 'Grey', hex: '#808080' },
        { id: 'heritage-brown', name: 'Heritage Brown', hex: '#5C4033' },
        { id: 'ral-custom', name: 'RAL Custom Colour', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
        { id: 'not-sure', name: 'Not Sure', hex: '#D3D3D3' },
      ];
    }

    // Aluminium doors colors
    if (product === 'aluminium-doors') {
      return [
        { id: 'grey', name: 'Grey', hex: '#808080' },
        { id: 'black', name: 'Black', hex: '#000000' },
        { id: 'black-matt', name: 'Black Matt', hex: '#28282B' },
        { id: 'white', name: 'White', hex: '#FFFFFF' },
        { id: 'special-colours', name: 'Special Colours', image: `${BASE_URL}/aluminium-doors/colours/special-colours.jpg` },
        { id: 'special-textured', name: 'Special Textured Finishes', image: `${BASE_URL}/aluminium-doors/colours/special-textured-finishes.jpg` },
        { id: 'ral-custom', name: 'RAL Custom Colour', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
        { id: 'not-sure', name: 'Not Sure', hex: '#D3D3D3' },
      ];
    }

    // Internal doors colors
    if (product === 'internal-products') {
      return [
        { id: 'black', name: 'Black', hex: '#000000' },
        { id: 'grey', name: 'Grey', hex: '#808080' },
        { id: 'white', name: 'White', hex: '#FFFFFF' },
        { id: 'ral-custom', name: 'RAL Custom Colour', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
        { id: 'not-sure', name: 'Not Sure', hex: '#D3D3D3' },
      ];
    }

    // Verandas & Pergolas colors
    if (product === 'verandas-pergolas') {
      return [
        { id: 'anthracite-grey-textured', name: 'Anthracite Grey Textured', hex: '#28282D' },
        { id: 'jet-black-textured', name: 'Jet Black Textured', hex: '#0A0A0A' },
        { id: 'white-semi-gloss', name: 'White Semi-Gloss', hex: '#F5F5F5' },
        { id: 'ral-custom', name: 'Custom RAL', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
        { id: 'not-sure', name: 'Not Sure', hex: '#D3D3D3' },
      ];
    }

    // Regular windows colors and bifolding/sliding/french doors
    if (product === 'windows' || product === 'bifolding-sliding-french-doors') {
      return [
        { id: 'anthracite-grey', name: 'Anthracite Grey', hex: '#28282D' },
        { id: 'white', name: 'White', hex: '#FFFFFF' },
        { id: 'black', name: 'Black', hex: '#000000' },
        { id: 'black-matt', name: 'Black Matt', hex: '#28282B' },
        { id: 'black-textured', name: 'Black Textured', hex: '#0A0A0A' },
        { id: 'agate-grey', name: 'Agate Grey', hex: '#b6b5b0' },
        { id: 'pebble-grey', name: 'Pebble Grey', hex: '#8B8680' },
        { id: 'black-grey', name: 'Black Grey', hex: '#3D3D3D' },
        { id: 'ral-custom', name: 'RAL Custom Colour', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
        { id: 'not-sure', name: 'Not Sure', hex: '#D3D3D3' },
      ];
    }

    // Default colors for other products
    return [
      { id: 'white', name: 'White', hex: '#FFFFFF' },
      { id: 'black', name: 'Black', hex: '#000000' },
      { id: 'grey', name: 'Grey', hex: '#808080' },
      { id: 'anthracite-grey', name: 'Anthracite Grey', hex: '#28282D' },
      { id: 'cream', name: 'Cream', hex: '#FFFDD0' },
      { id: 'chartwell-green', name: 'Chartwell Green', hex: '#3F5642' },
      { id: 'rosewood', name: 'Rosewood', hex: '#65000B' },
      { id: 'irish-oak', name: 'Irish Oak', hex: '#946A3F' },
      { id: 'golden-oak', name: 'Golden Oak', hex: '#B8956B' },
      { id: 'ral-custom', name: 'RAL Custom Colour', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },
    ];
  };

  const colours = getColours();

  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Choose Your Colour
      </h2>

      {/* Colour Grid */}
      <div className="mx-auto max-w-[1000px] px-4">
        <div className={`grid gap-4 ${product === 'front-back-doors' ? 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5' : 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4'}`}>
          {colours.map((colour) => (
            <button
              type="button"
              key={colour.id}
              onClick={() => onSelect(colour.id)}
              className={`
                group relative flex flex-col items-center rounded-lg border-2 p-4 transition-all
                ${
                  selectedColour === colour.id
                    ? 'border-[#ED6B64] bg-gray-50'
                    : 'border-gray-200 hover:border-gray-300'
                }
              `}
            >
              {/* Colour Swatch */}
              {colour.image ? (
                <div className="mb-3 h-20 w-20 overflow-hidden rounded-full border-2 border-gray-300 shadow-md">
                  <img
                    src={colour.image}
                    alt={colour.name}
                    className="h-full w-full object-cover"
                  />
                </div>
              ) : (
                <div
                  className={`
                    mb-3 h-20 w-20 rounded-full border-2 border-gray-300 shadow-md
                    ${colour.id === 'white' || colour.id === 'white-grain' || colour.id === 'heritage-white' ? 'border-gray-400' : ''}
                  `}
                  style={{
                    background: colour.hex?.startsWith('linear-gradient')
                      ? colour.hex
                      : colour.hex,
                  }}
                />
              )}

              {/* Colour Name */}
              <span className="text-center text-sm font-medium text-black">
                {colour.name}
              </span>

              {/* Selected Indicator */}
              {selectedColour === colour.id && (
                <div className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-[#ED6B64]">
                  <svg
                    className="h-4 w-4 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              )}
            </button>
          ))}
        </div>

        {/* Note */}
        <div className={'flex items-center justify-center w-full'}>

        <p className="mx-auto mt-8 text-center text-sm text-gray-600">
          Note: Final colour may vary slightly from on-screen representation.
          We recommend viewing physical samples before final selection.
        </p>
        </div>
      </div>
    </div>
  );
};

export default ColourStep;
